import React, { Component } from 'react';
import './Loader.css';

class ImportExportLoader extends Component {
  render() {
    const { text } = this.props;
    return <span className="importExportLoader">{text}</span>;
  }
}
export default ImportExportLoader;
